module.exports = __webpack_public_path__ + "static/img/si.c15b107.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/si.png
// module id = fJRb
// module chunks = 1